/**
 * 入力形式定義
 */
export class AnswerFormats {
  // テキスト入力
  static readonly TEXT: AnswerFormat = {
    num: 1,
    name: 'text',
  }
  // 単一選択
  static readonly SINGLE_CHOICE: AnswerFormat = {
    num: 2,
    name: 'single_choice',
  }
  // 複数選択
  static readonly MULTI_CHOICE: AnswerFormat = {
    num: 3,
    name: 'multi_choice',
  }
  // プルダウン選択
  static readonly MULTI_PULLDOWN: AnswerFormat = {
    num: 4,
    name: 'multi_pulldown',
  }
  // 手書き＋数式キーボード
  static readonly TEGAKI_AND_MATH_KEYBOARD: AnswerFormat = {
    num: 5,
    name: 'tegaki_and_math_keyboard',
    isKeyboard: true,
    isTegaki: true,
    isMathKeyboard: true,
  }
  // 手書き（端末キーボード使用可能）
  static readonly TEGAKI_AND_STANDARD_KEYBOARD: AnswerFormat = {
    num: 6,
    name: 'tegaki_and_standard_keyboard',
    isTegaki: true,
    canStandardKeyboard: true,
  }
  // 手書き
  static readonly TEGAKI: AnswerFormat = {
    num: 7,
    name: 'tegaki',
    isTegaki: true,
  }
  // 化学式キーボード
  static readonly SCIENCE_KEYBOARD: AnswerFormat = {
    num: 8,
    name: 'science_keyboard',
    isKeyboard: true,
    isScienceKeyboard: true,
  }
  // テキストエリア
  static readonly TEXTAREA: AnswerFormat = {
    num: 10,
    name: 'textarea',
  }
  // 並び替え
  static readonly SORT_CHOICE: AnswerFormat = {
    num: 11,
    name: 'sort_choice',
  }
  // 英文手書き
  static readonly TEGAKI_ENGLISH: AnswerFormat = {
    num: 12,
    name: 'tegaki_english',
    isTegaki: true,
    isEnglishTegaki: true,
  }
}

export type AnswerFormat = {
  // 番号
  num: number
  // 名称
  name: AnswerFormatName
  // キーボードを使用
  isKeyboard?: boolean
  // 手書きを使用
  isTegaki?: boolean
  // 端末キーボード入力可能
  canStandardKeyboard?: boolean
  // 数式キーボード
  isMathKeyboard?: boolean
  // 化学式キーボード
  isScienceKeyboard?: boolean
  // 英文手書き
  isEnglishTegaki?: boolean
}

export const AnswerFormatEnum = Object.freeze({
  1: 'text',
  2: 'single_choice',
  3: 'multi_choice',
  4: 'multi_pulldown',
  5: 'tegaki_and_math_keyboard',
  6: 'tegaki_and_standard_keyboard',
  7: 'tegaki',
  8: 'science_keyboard',
  9: 'self_scoring',
  10: 'textarea',
  11: 'sort_choice',
  12: 'tegaki_english',
} as const)

export type AnswerFormatName = (typeof AnswerFormatEnum)[keyof typeof AnswerFormatEnum]
